<template>
  <Header />
  <div v-if="step === 1 && !orderPlaced">
    <div class="section section--pb">
      <div class="customer-top">
        <div class="content-sm">
          <div class="d-flex columns">
            <div v-if="user?.avatar?.url" class="customer-avatar col-num" v-bind:style="{ 'background': 'url(' + user.avatar.url + ')' }"></div>
            <div v-else class="col-num " :class="'col-num--'+user.tier">
              {{ user.tier }}
            </div>
            <div class="customer-top__info">
              <div class="top-caption">New Order for:</div>
              <h1>{{ user.first_name }} {{ user.last_name }}</h1>
              <div v-if="user.types.length > 0" class="customer-types-container">
                <CustomerTypesTable
                  :customerTypes="user.types"
                  :customerSubTypes="user.sub_types"
                />
              </div>
              <div class="d-flex customer__switch-box" :class="{ 'customer__switch-box--active': matchedResults }">
                <div class="d-flex switch-group">
                  <input class="switch" type="checkbox" id="switch" checked v-model="matchedResults"
                         @change="loadResults" :disabled="!allProducts || seedingBuy"/>
                  <label for="switch"></label>
                </div>
                <div class="customer__list">
                  <span>Saved Sizes:</span>

                  <span>Tops: {{ user.tops_sizes_confirmed ? this.sortedSizes(user.tops).map((size) => `${size}*`).join(', ') : this.sortedSizes(user.tops).join(', ') }}</span>
                  <span>Bottoms: {{ user.bottoms_sizes_confirmed ? this.sortedSizes(user.bottoms).map((size) => `${size}*`).join(', ') : this.sortedSizes(user.bottoms).join(', ') }}</span>
                  <span>Headwear: {{ user.headwear_sizes_confirmed ? this.sortedHeadWearSizes(user.fitted_hats).map((size) => `${size}*`).join(', ') : this.sortedHeadWearSizes(user.fitted_hats).join(', ') }}</span>
                  <span>Footwear: {{ user.footwear_sizes_confirmed ? user.footwear.map((s) => parseInt(s)).sort((a, b) => a - b).map((size) => `${size}*`).join(', ') : user.footwear.map((s) => parseInt(s)).sort((a, b) => a - b).join(', ') }}</span>
                  <span>Accessories: {{ user.accessories_sizes_confirmed ? this.sortedSizes(user.accessories).map((size) => `${size}*`).join(', ') : this.sortedSizes(user.accessories).join(', ') }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="tabs" data-simplebar>
        <div class="content-sm">
          <ul class="tabs-nav">
            <li>
              <button data-tab="tab-live-product" class="btn btn--light tab-toggle"
                      :class="allProducts && !seedingBuy ? 'active' : ''"
                      :disabled="orderLocation === 'seeding_buy'"
                      @click="liveProductActive">Live Product
              </button>
            </li>
            <li>
              <button data-tab="tab-draft-product" class="btn btn--light tab-toggle"
                      :class="!allProducts && !seedingBuy ? 'active' : ''"
                      :disabled="orderLocation === 'seeding_buy'"
                      @click="draftProductActive">Draft Product
              </button>
            </li>
            <li>
              <button data-tab="tab-seeding-product" class="btn btn--light tab-toggle"
                      :class="seedingBuy ? 'active' : ''"
                      :disabled="orderLocation === 'warehouse'"
                      @click="seedingProductActive">Seeding-Buy
              </button>
            </li>
          </ul>
        </div>
      </div>
      <div class="form product-search">
        <div class="form-group">
          <input type="text" placeholder="Search for Product" class="form-control" v-model="searchTerm" @keyup="searchProductsByTerm()">
        </div>
      </div>
      <div class="container content-products">
        <div class="loading-spinner" v-if="isLoading" />
        <div class="panel-collapse panel" id="tab-live-product">
          <div class="panel__content">
            <div class="grid grid-products" :class="allProducts ? 'all' : 'draft'" v-if="!searchProducts && !seedingBuy">
              <div class="grid-col" v-for="(product, index) in products" :key="product.id" @click="clickProduct(product.id)" :class="[selectedProducts.indexOf(product.id) > -1 ? 'grid-col-checked' : '', product.status]" :data-id="product.id" :data-counter="index">
                <div class="image-square">
                  <span v-if="soldOut(product)" class="badge">SOLD OUT</span>
                  <span v-if="product.tags && product.tags.includes('dev-coming-soon')" class="badge">COMING SOON</span>
                  <img :src="`${product.image.src}&width=400`" alt="" v-if="product.image != null" />
                  <img :src="`${product.image_url}&width=400`" alt="" v-if="product.image_url != null" />
                </div>
              </div>
            </div>
            <div class="grid grid-products" v-if="!searchProducts && seedingBuy">
              <div class="grid-col" v-for="(product, index) in products" :key="product.id" @click="clickProduct(product.id)" :class="[selectedProducts.indexOf(product.id) > -1 ? 'grid-col-checked' : '', product.status]" :data-id="product.id" :data-counter="index">
                <div class="image-square">
                  <span v-if="soldOut(product)" class="badge">SOLD OUT</span>
                  <span v-if="product.tags && product.tags.includes('dev-coming-soon')" class="badge">COMING SOON</span>
                  <img :src="`${product.image.src}&width=400`" alt=""  v-if="product.image != null" />
                  <img :src="`${product.image_url}&width=400`" alt=""  v-if="product.image_url != null" />
                </div>
              </div>
            </div>
            <div class="grid grid-products" :class="allProducts ? 'all' : 'draft'" v-if="searchProducts">
              <div class="grid-col" v-for="(product, index) in searchResults" :key="product.id" @click="clickProduct(product.id)" :class="[selectedProducts.indexOf(product.id) > -1 ? 'grid-col-checked' : '', product.status]" :data-id="product.id" :data-counter="index">
                <div class="image-square">
                  <span v-if="soldOut(product)" class="badge">SOLD OUT</span>
                  <span v-if="product.tags && product.tags.includes('dev-coming-soon')" class="badge">COMING SOON</span>
                  <img :src="`${product.image.src}&width=400`" alt=""  v-if="product.image != null" />
                  <img :src="`${product.image_url}&width=400`" alt=""  v-if="product.image_url != null" />
                </div>
              </div>
            </div>
            <div class="buttons order-buttons-box" :class="selectedProducts.length === 0 ? '' : 'grid'">
              <button class="btn btn--light order-button drawer-toggle" data-drawer="review-order" v-if="selectedProducts.length > 0" @click="showCartDrawer()">Review Order</button>
              <button class="btn btn--primary" :disabled="selectedProducts.length === 0 || user.tier === null" @click="draftOrder()">Draft Order</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="overlay-drawer"></div>
    <div class="drawer" id="review-order" :class="showSizes === true ? 'active-drawer' : ''">
      <div class="content container">
        <button class="drawer__close" @click="cancelSelectionOfProduct()"><i class="icon icon--down"></i></button>
        <div class="drawer__content" data-simplebar>
          <div class="heading">
            <h1>Please Select a Size</h1>
          </div>
          <div class="grid-sm">
            <li
              class="btn btn-size"
              v-for="variant in sortBySize(selectedProduct.variants)"
              :key="variant.id"
              :class="[(variant.inventory_quantity > 0 || variant.inventory > 0) ? '' : 'size-unavailable', tempSelectedSizes.find(item => item.id === variant.id)? 'size-chosen' : '', selectedProduct.matchedSize?.includes(variant.size_name) || selectedProduct.matchedSize?.includes(variant.size) ? 'size-preselected' : '']"
              @click="selectVariant(variant.id)">
              <span v-if="variant.size != null">{{ this.size(selectedProduct, variant.size) }}</span>
              <span v-if="variant.size_name != null">{{ this.size(selectedProduct, variant.size_name) }}</span>
            </li>
          </div>
          <div class="buttons order-buttons-box grid">
            <button class="btn btn--light order-button" type="button" @click="cancelSelectionOfProduct()">Back</button>
            <button class="btn btn--primary" type="button" @click="addToOrder()">Add to Order</button>
          </div>
        </div>
      </div>
    </div>

    <div class="drawer" id="review-orderx" :class="showCart === true ? 'active-drawer' : ''">
      <div class="content container">
        <button class="drawer__close" @click="closeDrawer"><i class="icon icon--down"></i></button>
        <div class="drawer__content" data-simplebar>
          <div class="heading">
            <h1>Review Order</h1>
          </div>
          <div class="order__header" >
            <span>NAME</span>
            <span>QUANTITY</span>
          </div>
          <div class="order__item" v-for="(product) in selectedItems" :key="product.id" :class="[product.status, {error: errorItem.length && errorItem.find(i => i.id === product.id)}]"
               :data-id="product.id">
            <img :src="product.image" alt=""/>
            <div class="item__details">
              <div>{{ product.title }}</div>
              <div class="item__color">{{ product.color_name }} / {{ product.size_name }}</div>
            </div>
            <div class="item__quantity">
              <select class="form-control" id="quantity" :value="tempQuantity[product.id] || product.quantity"
                      @change="saveTempQuantity($event.target.value, product.id, product)">
                <option :key="quantity" :value="quantity" v-for="quantity in [0,1,2,3,4,5,6,7,8,9,10]">{{ quantity }}</option>
              </select>
            </div>
          </div>

          <div class="item__error" v-if="errorItem.length">
            Please note:<br>
            The selected quantity is not available for {{errorItem[0].title}} in {{errorItem[0].color}}, size {{errorItem[0].size}}. There are {{errorItem[0].inventory}} remaining units available.
          </div>

          <div class="buttons order-buttons-box grid">
            <button class="btn btn--light order-button" type="button" @click="updateOrder()" :disabled="!unsaveQuantity || errorItem.length">Save</button>
            <button class="btn btn--primary" type="button" :disabled=placingOrder @click="placeReviewedOrder()">Place order</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-if="step === 2 && !orderPlaced">
    <div class="section section--pb">
      <div class="content-sm">
        <div class="columns">
          <h1 class="heading">Notification Preferences</h1>
          <div class="notification__info">
            <div>Recipient: {{ user.first_name }} {{ user.last_name }}</div>
          </div>
          <div class="notification__info">
            <div>{{ user.address1 }}</div>
            <div v-if="user.address2">{{ user.address2 }}</div>
            <div>{{ user.city }}, {{ user.zip }}</div>
            <div>{{ user.country }}</div>
            <div>{{ user.phone }}</div>
          </div>
          <div class="form-group">
            <div class="form-group form-radio-group">
              <label class="form-radio-button">
                <input v-model="user.notification_preference"
                       :value="dictionaries.notificationPreferences.all.value"
                       type="radio">{{ dictionaries.notificationPreferences.all.label }}</label>
              <label class="form-radio-button">
                <input v-model="user.notification_preference"
                       :value="dictionaries.notificationPreferences.shipping.value"
                       type="radio">{{ dictionaries.notificationPreferences.shipping.label }}</label>
              <label class="form-radio-button">
                <input v-model="user.notification_preference"
                       :value="dictionaries.notificationPreferences.none.value"
                       type="radio">{{ dictionaries.notificationPreferences.none.label }}</label>
            </div>
          </div>
          <div class="buttons order-buttons-box" :class="'grid'">
            <p class="form-error form-error--full-width" v-if="isAddressTooLong()">Before continuing, please ensure both address lines are limited to 30 characters.</p>
            <button class="btn btn--secondary" @click="cancelOrder()">Cancel Order</button>
            <button v-if="user.country === 'United States'" class="btn btn--primary" :disabled="isAddressTooLong()" @click="continueOrder()">Continue</button>
            <button v-else class="btn btn--primary" :disabled=placingOrder @click="placeOrder()">Place Order</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-if="step === 3 && !orderPlaced">
    <div class="section section--pb">
      <div class="content-sm">
        <div class="columns">
          <h1 class="heading">Confirm Shipping Method</h1>
          <div class="notification__info">
            <div>Recipient: {{ user.first_name }} {{ user.last_name }}</div>
          </div>
          <div class="notification__info">
            <div>{{ user.address1 }}</div>
            <div v-if="user.address2">{{ user.address2 }}</div>
            <div>{{ user.city }}, {{ user.zip }}</div>
            <div>{{ user.country }}</div>
            <div>{{ user.phone }}</div>
          </div>
          <div class="form-group">
            <div class="form-group shipping-method">
              <div class="form-radio-button shipping-method__header">
                <span>Shipping method</span>
                <span>estimated delivery</span>
              </div>
              <label class="form-radio-button">
                <input v-model="user.shipping_method"
                       :value="'standard'"
                       type="radio"><span>Standard Shipping</span><span class="shipping-method__date">{{ formatDate(deliveryEstimates.estimated_standard_delivery) }}</span></label>
              <label class="form-radio-button">
                <input v-model="user.shipping_method"
                       :value="'expedited'"
                       type="radio"><span>Expedited Shipping</span><span class="shipping-method__date">{{ formatDate(deliveryEstimates.estimated_expedited_delivery) }}</span></label>
            </div>
          </div>
          <p class="form-error" v-if="currentUserError">{{currentUserError}}</p>
          <div class="buttons order-buttons-box" :class="'grid'">
            <button class="btn btn--secondary" @click="cancelOrder()">Cancel Order</button>
            <button class="btn btn--primary" :disabled=placingOrder @click="placeOrder()">Place Order</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="section container">
    <div class="content" v-if="orderPlaced">
      <div class="full-page-confirmation">
        <p>New order created successfully!</p>
      </div>
    </div>
  </div>
</template>

<script>
import 'simplebar/dist/simplebar.min.css';
import Header from '../components/Header.vue';
import CustomerTypesTable from '../components/CustomerTypesTable.vue';
import { reactive, toRaw } from 'vue';

export default {
  name: 'CreateOrder',
  components: {
    Header,
    CustomerTypesTable
  },
  data() {
    return {
      step: 1,
      placingOrder: false,
      deliveryEstimates: {
        estimated_standard_delivery: '',
        estimated_expedited_delivery: '',
      },
      user: {
        email: '',
        first_name: '',
        last_name: '',
        accessories: [],
        address1: '',
        address2: '',
        bottoms: [],
        city: '',
        country: '',
        fitted_hats: [],
        footwear: [],
        id: this.$route.params.userid,
        instagram_handle: '',
        phone: '',
        province: '',
        tops: [],
        zip: '',
        shipping_method: 'standard',
        types: [],
        sub_types: []
      },
      products: null,
      showSizes: false,
      showCart: false,
      allProducts: true,
      seedingBuy: false,
      orderLocation: '',
      selectedProducts: [],
      productsToRemove: [],
      selectedItems: [],
      tempSelectedSizes: [],
      tempQuantity: {},
      searchTerm: '',
      searchProducts: false,
      searchResults: [],
      selectedProduct: {},
      matchedResults: true,
      isLoading: true,
      unsaveQuantity: false,
      orderPlaced: false,
      errorItem: [],
      currentUserError: null,
    }
  },
  methods: {
    sortedSizes(sizes) {
      let weights = {
        'XXS': 1,
        'XS': 2,
        'S': 3,
        'M': 4,
        'L': 5,
        'XL': 6,
        'XXL': 7
      };
      let sorted = sizes.sort((a, b) => weights[a] - weights[b]);
      return sorted
    },
    sortedHeadWearSizes(sizes) {
      let weights = {
        "OS": 1,
        "S/M": 2,
        "L/XL": 3,
        "7": 4,
        "7⅛": 5,
        "7¼": 6,
        "7⅜": 7,
        "7½": 8,
        "7⅝": 9,
        "7¾": 10,
        "7⅞": 11
      }
      let sorted = sizes.sort((a, b) => weights[a] - weights[b]);
      return sorted
    },
    size(product, size) {
      let confirmationAttribute = this.cofirmationAttribute(product)
      let confirmed = this.user[confirmationAttribute]
      let customerSizes = this.user[product.type]
      if (customerSizes == undefined) {
        return size;
      }
      if (confirmed && customerSizes.includes(size)) {
        return `${size}*`;
      } else {
        return size
      }
    },
    cofirmationAttribute(product) {
      switch (product.type) {
        case 'fitted_hats':
          return 'headwear_sizes_confirmed';
        case 'tops':
          return 'tops_sizes_confirmed';
        case 'bottoms':
          return 'bottoms_sizes_confirmed';
        case 'footwear':
          return 'footwear_sizes_confirmed';
        case 'accessories':
          return 'accessories_sizes_confirmed';
        default:
          return 'accessories_sizes_confirmed';
      }
    },
    validateCart(variants) {
      if (!variants || !variants.length) {
        this.orderLocation = '';
        return;
      }

      if (variants.some(v => v.inventory_name === "Seeding Buy")) {
        this.orderLocation = 'seeding_buy';
      } else {
        this.orderLocation = 'warehouse';
      }
    },
    soldOut(product) {
      return product.variants.every(variant => variant.inventory === 0) && !product.tags.includes('dev-coming-soon')
    },
    selectVariant(variantId) {
      const index = this.tempSelectedSizes.findIndex(i => i.id === variantId);
      if (index > -1) {
        this.tempSelectedSizes.splice(index, 1);
      } else {
        const item = this.selectedProduct.variants.find(v => v.id === variantId);
        item.title = this.selectedProduct.title;
        item.productId = this.selectedProduct.id;
        item.quantity = 1;
        item.image = this.selectedProduct.image?.src || this.selectedProduct.image_url;
        this.tempSelectedSizes.push(item);
      }

      this.validateCart(this.tempSelectedSizes);
    },
    saveTempQuantity(value, variantId, item){
      this.tempQuantity[variantId] = value;
      if (item.inventory < value) {
        this.errorItem.push({
          title: item.title,
          color: item.color_name,
          size: item.size_name,
          inventory: item.inventory,
          id: item.id,
        });
      } else {
        const index = this.errorItem.findIndex(i => i.id === item.id);
        if (index > -1) {
          this.errorItem.splice(index, 1);
        }
      }

      this.unsaveQuantity = true;
    },
    updateOrder() {
      this.unsaveQuantity = false;
      this.selectedItems.forEach(item => {
        const newQuantity = this.tempQuantity[item.id];
        if (newQuantity) {
          item.quantity = parseInt(newQuantity, 10);
        }
      });

      this.selectedItems = this.selectedItems.filter(item => {
        if (!item.quantity) {
          const index = this.selectedProducts.indexOf(item.productId);
          if (index > -1) {
            this.selectedProducts.splice(index, 1);
          }
        }
        return item.quantity;
      });
      this.tempQuantity = {};
      this.validateCart(this.selectedItems);
    },
    addToOrder(){
      this.selectedItems = [...this.tempSelectedSizes];
      this.tempSelectedSizes.length = 0;
      this.showSizes = false;
      document.body.classList.toggle('drawer-open');
    },
    cancelSelectionOfProduct() {
      this.showSizes = false;
      this.tempSelectedSizes.length = 0;
      document.body.classList.toggle('drawer-open');
      this.selectedProducts.pop();
    },
    searchProductsByTerm() {
      if(this.searchTerm.length > 0) {
        this.searchProducts = true;
        this.searchResults = this.products.filter((element, index) => {
          console.log(index);
          return element.title.toLowerCase().indexOf(this.searchTerm.toLowerCase()) > -1
        });
      } else {
        this.searchProducts = false;
      }
      return false;
    },
    clearSearch() {
      this.searchProducts = false;
      this.searchResults = [];
      this.searchTerm = '';
    },
    clickProduct(id) {
      this.selectedProducts.push(id);
      let pickCorrectProduct = '';

      for (var i in this.products) {
        if (this.products[i].id == id) {
          pickCorrectProduct = this.products[i];
        }
      }

      let tempSelected = toRaw(reactive(pickCorrectProduct));

      let footwearSizing = this.user.footwear;
      let topsSizing = this.user.tops;
      let accessoriesSizing = this.user.accessories;
      let bottomsSizing = this.user.bottoms;
      let fittedHatsSizing = this.user.fitted_hats;
      // accessories -> accessories
      // tops => tees, shirting, knits, sweatshirts, outerwear, sweaters, woven shirts
      // fitted hats => headwear, hats
      // footwear => footwear
      // bottoms => pants, shorts, sweats, sweatpants, sweatshorts

      const accessoriesNames = ['accessories', 'bags', 'jewelry'];
      const topsNames = ['tees', 'outerwear', 'shirting', 'knits', 'sweatshirt', 'sweatshirts', 'suits', 'hoodies', 'sweaters', 'knitwear1', 'knitwear', 'woven shirts', 'crewneck', 'shirt'];
      const hatsNames = ['headwear', 'hats'];
      const footwearNames = ['footwear', 'shoes'];
      const bottomsNames = ['pants', 'shorts', 'sweats', 'sweatpants', 'sweatshorts', 'belt'];

      if (tempSelected.product_collections !== undefined) {
        if (tempSelected.product_collections.some(r => footwearNames.includes(r))) {
          tempSelected.matchedSize = footwearSizing;
        } else if (tempSelected.product_collections.some(r => accessoriesNames.includes(r))) {
          tempSelected.matchedSize = accessoriesSizing
        } else if (tempSelected.product_collections.some(r => bottomsNames.includes(r))) {
          tempSelected.matchedSize = bottomsSizing
        } else if (tempSelected.product_collections.some(r => topsNames.includes(r))) {
          tempSelected.matchedSize = topsSizing
        } else if (tempSelected.product_collections.some(r => hatsNames.includes(r))) {
          tempSelected.matchedSize = fittedHatsSizing
        }
      } else if (tempSelected.product_type !== undefined) {
        const productType = tempSelected.product_type.toLowerCase();
        if (footwearNames.includes(productType)) {
          tempSelected.matchedSize = footwearSizing;
        } else if (accessoriesNames.includes(productType)) {
          tempSelected.matchedSize = accessoriesSizing
        } else if (bottomsNames.includes(productType)) {
          tempSelected.matchedSize = bottomsSizing
        } else if (topsNames.includes(productType)) {
          tempSelected.matchedSize = topsSizing
        } else if (hatsNames.includes(productType)) {
          tempSelected.matchedSize = fittedHatsSizing
        }
      } else {
        tempSelected.matchedSize = '';
      }

      this.selectedProduct = toRaw(reactive(pickCorrectProduct))
      this.tempSelectedSizes =  [...this.selectedItems];

      this.showSizes = true;
      document.body.classList.toggle('drawer-open');
    },
    closeDrawer() {
      this.showSizes = false;
      this.showCart = false;
      document.body.classList.toggle('drawer-open');
    },
    draftOrder() {
      this.step = 2;
    },
    continueOrder() {
      this.step = 3;
    },
    cancelOrder(){
      this.$router.push('/home/');
    },
    placeReviewedOrder() {
      this.step = 2;
    },
    placeOrder() {
      this.placingOrder = true;
      this.updateOrder();
      if (this.currentUser == undefined) {
        this.currentUserError = "Unable to assign order to current user. Please sign in again.";
        this.placingOrder = false;
        return;
      }
      this.currentUserError = null;

      this.axios.post(`/v1/customers/${this.user.id}/orders.json`, {
        record: {
          shipping_method: this.user.shipping_method,
          notification_preference: this.user.notification_preference,
          variant_ids: this.selectedItems,
          location: this.orderLocation,
          drafted_by: this.currentUser.name,
        }
      }).then(() => {
        if (document.body.classList.contains('drawer-open')) {
          document.body.classList.toggle('drawer-open');
        }
        this.orderPlaced = true;
        this.placingOrder = false;
        setTimeout(this.redirectToHome, 3000);
      })
     .catch((error) => { console.log(error) });
    },
    redirectToHome() {
      this.$router.push('/home/');
    },
    liveProductActive() {
      this.clearSearch();
      if (!this.allProducts || this.seedingBuy) {
        if (this.matchedResultsSwitchChanged) {
          this.matchedResults = true;
        }
        this.allProducts = true;
        this.seedingBuy = false;
        this.loadResults();
      }
    },
    draftProductActive() {
      this.clearSearch();
      if (this.allProducts || this.seedingBuy) {
        // remember previous state of the size switch
        this.matchedResultsSwitchChanged = false;

        if (this.matchedResults) {
          this.matchedResults = false;
          this.matchedResultsSwitchChanged = true;
        }

        this.allProducts = false;
        this.seedingBuy = false;
        this.loadResults();
      }
    },
    seedingProductActive() {
      this.clearSearch();
      if (!this.seedingBuy) {
        this.seedingBuy = true;
        this.matchedResults = false;
        this.loadSeedingResults()
      }
    },
    showCartDrawer() {
      this.showCart = true;
      document.body.classList.toggle('drawer-open');
    },
    getFilterProduct(user){
      this.products = []
      this.isLoading = true;
      let appurl = 'aime-leon-dore-dev-store';
      if (process.env.NODE_ENV === 'production') {
        appurl = 'aime-leon-dore';
      }
      const accessoriesRequest = this.axios({
        url: 'https://api.aimeleondore.com/api/filter_products',
        method: 'post',
        data: {
          collection: "accessories",
          store_name: appurl,
          sizes: [],
          colors: [],
          display_sold_out: true,
          seeding_app: true
        }
      });
      let sizes = [user.accessories[0], user.bottoms[0], user.fitted_hats[0], user.footwear[0], user.tops[0]];
      const allHatSizes = ["OS", "S/M", "L/XL", "7", "7⅛", "7¼", "7⅜", "7½", "7⅝", "7¾", "7⅞"];
      if(user.fitted_hats[0]) {
        sizes = [user.accessories[0], user.bottoms[0], user.footwear[0], user.tops[0]].concat(allHatSizes);
      }
      const productsRequest = this.axios({
        url: `/v1/products/active?user_id=${user.id}&store_name=${appurl}&order_by=published_at&sizes=${sizes}&colors=[]&accessoriesSizes=${user.accessories}&bottomsSizes=${user.bottoms}&hatsSizes=${allHatSizes}&footwearSizes=${user.footwear}&topsSizes=${user.tops}&display_sold_out=${true}`,
        method: 'get',
        data: {
          store_name: appurl,
          colors: [],
          order_by: "published_at",
        }
      })
      this.axios.all([productsRequest, accessoriesRequest])
        .then(this.axios.spread((...responses) => {
          this.isLoading = false;
          let productsData = responses[0].data.records;
          let accessoriesOS = responses[1].data.filter(a => a.size_range === null); // accessories size OS
          productsData.push(...accessoriesOS);
          for (let i in productsData) {
            productsData[i].id = productsData[i].product_id || productsData[i].id;
            productsData[i].source = 'warehouse';
          }
          let uniqueProducts = productsData.filter((elem, index) => productsData.findIndex(obj => obj.id === elem.id) === index);
          this.products = uniqueProducts;
        }))
        .catch(error => {
          console.log('error', error)
        });
    },
    loadResults() {
      this.products = [];
      this.isLoading = true;
      if(!this.matchedResults) {
        this.axios.get(`/v1/products/${this.allProducts ? 'index': 'draft'}.json`).then(response => {
          let products = response.data.records
          this.isLoading = false;
          this.products = products;
        }).catch((error) => { console.log(error) });
      } else {
        this.getFilterProduct(this.user);
      }
    },
    loadSeedingResults() {
      this.products = []
      this.isLoading = true;
      this.axios.get(`/v1/products/seeding_buy.json`).then(response => {
        for (let i in response.data.records) {
          response.data.records[i].source = 'seeding_buy';
        }
        this.isLoading = false;
        this.allProducts = true;
        this.products = response.data.records;
      }).catch((error) => {
        console.log(error)
      });
    },
    formatDate(date) {
      if (!date) {
        return 'N/A';
      }
      return this.helpers.formatDate(date);
    },
    sortBySize(variants) {
      const regexpCoordinates = /[a-z]/i;
      const getPoints = (size) => {
        if (regexpCoordinates.test(size)) {
          return size === 'M' ? 0 : size?.length * (size?.includes('S') ? -1 : 1);
        }
        return size;
      }

      if (variants && variants.length) {
        const sizeName = variants[0].size ? 'size' : 'size_name';
        return variants.map(variant => ({
          variant,
          points: getPoints(variant[sizeName])
        })).sort((a, b) => a.points - b.points).map(({ variant }) => variant);
      }
    },
    isAddressTooLong() {
      if (this.user.country !== 'United States') {
        return false;
      }
      return this.user.address1?.length > 30 || this.user.address2?.length > 30;
    }
  },
  mounted() {
    if (document.body.classList.contains('drawer-open')) {
      document.body.classList.toggle('drawer-open');
    }
    console.log(this.matchedResults, 'getting products from filters app')

    this.axios.get(`/v1/customers/${this.user.id}.json`).then(response => {
      this.user = response.data.record;
      this.user.shipping_method = this.user.shipping_method || 'standard';
      this.getFilterProduct(response.data.record);

      if (this.user.zip && this.user.country === 'United States') {
        this.axios.get(`/v1/delivery_estimates/${this.user.zip}.json`).then(response => {
          this.deliveryEstimates = response.data;
        }).catch((error) => {
          console.warn(error.message);
        });
      }
    }).catch((error) => { console.log(error) });
  }
}
</script>

<style scoped>
.order__header{
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #E5E5E5;
  font-size: 10px;
  color: #181818;
  padding-bottom: 8px;
}
select {
  background: #ffffff url(../assets/images/icon_arrow_down.svg) no-repeat 54px center;
  background-size: 12px 7px;
  width: 80px;
  height: 40px;
  padding: 0 16px 0 16px;
  color: #000;
}
.item__quantity:after{
  content: '';
  height: 40px;
  width: 1px;
  background: #E5E5E5;
  position: absolute;
  left: 40px;
  top:0;
}

.customer-avatar {
    background-position: center center !important;
    background-size: 120% auto !important;
    background-repeat: no-repeat !important;
  }


.order__item {
  display: flex;
  align-items: center;
  border-bottom: 1px solid #E5E5E5;
}

.order__item img {
  height: 50px;
  margin-right: 12px;
}

@media screen and (min-width: 992px) {
  .order__item img {
    height: 100px;
  }
}

.item__quantity {
  margin-left: auto;
  position: relative;
}

.item__color {
  color: #C4C4C4;
}

.notification__info {
  margin-bottom: 32px;
}

.shipping-method {
  border-bottom: 1px solid #E5E5E5;
}

.shipping-method .form-radio-button {
  display: flex;
  align-items: center;
  height: 60px;
}

.loading-spinner {
  background: url(../assets/images/loading_spinner.gif) no-repeat center center;
  width: 400px;
  height: 400px;
  margin: auto;
}

.shipping-method__date {
  margin-left: auto;
  margin-right: 12px
}

.shipping-method .shipping-method__header {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  text-transform: uppercase;
  font-size: 0.625rem;
}

.customer-type-container {
  padding: 1px 4px;
  display: flex;
  justify-content: center;
  margin-right: 5px;
  align-items: center;
  text-align: center;
  letter-spacing: 0.05em;
  background-color: #F7F7F7;
  border: 1px solid #E5E5E5;
}
.tab-toggle {
  color: black;
}

.item__error {
  margin-top: 16px;
  font-size: 10px;
  line-height: 14px;
  color: #D43F21;
}

.order-button {
  color: black;
}

.error .item__details, .error .item__color, .error select {
  color: #D43F21;
}

.form-error {
  color: red;
}

.form-error--full-width {
  grid-column: 1 / -1;
  width: 100%;
  margin-bottom: 8px;
  text-align: center;
}

.badge {
  color: #D43F21;
  position: absolute;
  top: 6px;
  left: 6px;
  z-index: 1;
}
</style>
